<div
    *ngIf="spinnerService.showLoadingSpinner()"
    class="absolute loadingSpinner z-99 bg-dialog flex flex-col justify-center">
    <div class="mx-auto my-auto spinner">
        <div class="bounce1"></div>
        <div class="bounce2"></div>
        <div class="bounce3"></div>
    </div>
</div>
